import { GeneratedSignTemplateParamsIdentity } from "../generated/domain-models/generated-sign-template-params.identity";

export class SignTemplateParamsIdentity extends GeneratedSignTemplateParamsIdentity {

}
